enum HeaderType {
  Category,
  Basket,
  Product,
  Order,
  OrderDetail,
  Wishlist,
  Search,
  News,
  NewsDetail,
  Stock,
  StockDetail,
  CatalogSections,
  Diseases,
  Popular,
  Sale,
  Pharmacies,
  PharmacyDetail,
  OrderPaymentResult,
  Default,
  Reviews,
  Preset,
  Categories,
  UserList,
  UserProduct,
  Novelties,
  Banner,
  LandingPage
}

export default HeaderType
